enum HeaderEnum {
  'about' = 'about',
  'show_thank_you_modal.congratulations' = 'show_thank_you_modal.congratulations',
  'show_thank_you_modal.email_verified' = 'show_thank_you_modal.email_verified',
  'show_thank_you_modal.log_in_and_explore_spiritory' = 'show_thank_you_modal.log_in_and_explore_spiritory',
  'mobile_app_banner.spiritory_whiskey_and_wine' = 'mobile_app_banner.spiritory_whiskey_and_wine',
  'mobile_app_banner.download_the_app' = 'mobile_app_banner.download_the_app',
  'mobile_app_banner.button_download' = 'mobile_app_banner.button_download',
  'main_menu.main_menu' = 'main_menu.main_menu',
  'main_menu.dashboard' = 'main_menu.dashboard',
  'main_menu.sign_in' = 'main_menu.sign_in',
  'main_menu.signup' = 'main_menu.signup',
  'main_menu.home' = 'main_menu.home',
  'main_menu.browse' = 'main_menu.browse',
  'main_menu.about' = 'main_menu.about',
  'main_menu.sell' = 'main_menu.sell',
  'browse_menu.browse' = 'browse_menu.browse',
  'browse_menu.main.status' = 'browse_menu.main.status',
  'browse_menu.main.brand' = 'browse_menu.main.brand',
  'browse_menu.main.countries' = 'browse_menu.main.countries',
  'browse_menu.main.topics' = 'browse_menu.main.topics',
  'browse_menu.status.status' = 'browse_menu.status.status',
  'browse_menu.status.has_bids' = 'browse_menu.status.has_bids',
  'browse_menu.status.has_asks' = 'browse_menu.status.has_asks',
  'browse_menu.countries.countries' = 'browse_menu.countries.countries',
  'browse_menu.countries.scotland' = 'browse_menu.countries.scotland',
  'browse_menu.countries.france' = 'browse_menu.countries.france',
  'browse_menu.countries.ireland' = 'browse_menu.countries.ireland',
  'browse_menu.countries.germany' = 'browse_menu.countries.germany',
  'browse_menu.countries.japan' = 'browse_menu.countries.japan',
  'browse_menu.countries.usa' = 'browse_menu.countries.usa',
  'browse_menu.countries.mexico' = 'browse_menu.countries.mexico',
  'browse_menu.topics.topics' = 'browse_menu.topics.topics',
  'browse_menu.topics.most_popular' = 'browse_menu.topics.most_popular',
  'browse_menu.topics.most_watched' = 'browse_menu.topics.most_watched',
  'browse_menu.topics.new' = 'browse_menu.topics.new',
  'about_menu.about_menu' = 'about_menu.about_menu',
  'about_menu.how_it_works' = 'about_menu.how_it_works',
  'about_menu.buyer_guide' = 'about_menu.buyer_guide',
  'about_menu.portfolio_guide' = 'about_menu.portfolio_guide',
  'about_menu.authentication' = 'about_menu.authentication',
  'about_menu.bottle_condition' = 'about_menu.bottle_condition',
  'about_menu.blog' = 'about_menu.blog',
  'about_menu.help' = 'about_menu.help',
  'sell_menu.sell_menu' = 'sell_menu.sell_menu',
  'sell_menu.seller_guide' = 'sell_menu.seller_guide',
  'sell_menu.has_bids' = 'sell_menu.has_bids',
  'sell_menu.shipping_guide' = 'sell_menu.shipping_guide',
  'sell_menu.bottle_condition' = 'sell_menu.bottle_condition',
  'sell_menu.become_a_seller' = 'sell_menu.become_a_seller',
  'dashboard_menu.main.dashboard' = 'dashboard_menu.main.dashboard',
  'dashboard_menu.main.buying' = 'dashboard_menu.main.buying',
  'dashboard_menu.main.selling' = 'dashboard_menu.main.selling',
  'dashboard_menu.main.portfolio' = 'dashboard_menu.main.portfolio',
  'dashboard_menu.main.wishlist' = 'dashboard_menu.main.wishlist',
  'dashboard_menu.main.last_viewed' = 'dashboard_menu.main.last_viewed',
  'dashboard_menu.main.suggest_a_bottle' = 'dashboard_menu.main.suggest_a_bottle',
  'dashboard_menu.main.notifications' = 'dashboard_menu.main.notifications',
  'dashboard_menu.main.settings' = 'dashboard_menu.main.settings',
  'dashboard_menu.main.language' = 'dashboard_menu.main.language',
  'dashboard_menu.main.logout' = 'dashboard_menu.main.logout',
  'dashboard_menu.main.referrals' = 'dashboard_menu.main.referrals',
  'dashboard_menu.settings_menu.your_account' = 'dashboard_menu.settings_menu.your_account',
  'dashboard_menu.settings_menu.buyer_profile' = 'dashboard_menu.settings_menu.buyer_profile',
  'dashboard_menu.settings_menu.seller_profile' = 'dashboard_menu.settings_menu.seller_profile',
  'dashboard_menu.settings_menu.services' = 'dashboard_menu.settings_menu.services',
  'dashboard_menu.settings_menu.feedback' = 'dashboard_menu.settings_menu.feedback',
  'locales.english' = 'locales.english',
  'locales.german' = 'locales.german',
  'locales.french' = 'locales.french',
  'locales.italian' = 'locales.italian',
  'locales.spanish' = 'locales.spanish',
  'locales.es' = 'locales.es',
  'locales.en' = 'locales.en',
  'locales.de' = 'locales.de',
  'locales.fr' = 'locales.fr',
  'locales.it' = 'locales.it',
  'go_back_buttons.go_back_to_main_menu' = 'go_back_buttons.go_back_to_main_menu',
  'go_back_buttons.go_back_to_browse_menu' = 'go_back_buttons.go_back_to_browse_menu',
  'go_back_buttons.go_back_to_dashboard_menu' = 'go_back_buttons.go_back_to_dashboard_menu',
  'common.open_menu' = 'common.open_menu',
  'common.menu' = 'common.menu',
  'mobile_menu.buy_spirits.buy_spirits' = 'mobile_menu.buy_spirits.buy_spirits',
  'mobile_menu.buy_spirits.type' = 'mobile_menu.buy_spirits.type',
  'mobile_menu.buy_spirits.brand' = 'mobile_menu.buy_spirits.brand',
  'mobile_menu.buy_spirits.countries' = 'mobile_menu.buy_spirits.countries',
  'mobile_menu.buy_spirits.topics' = 'mobile_menu.buy_spirits.topics',
  'mobile_menu.sell_spirits.sell_spirits' = 'mobile_menu.sell_spirits.sell_spirits',
  'mobile_menu.sell_spirits.become_a_seller' = 'mobile_menu.sell_spirits.become_a_seller',
  'mobile_menu.sell_spirits.seller_guide' = 'mobile_menu.sell_spirits.seller_guide',
  'mobile_menu.sell_spirits.authentication' = 'mobile_menu.sell_spirits.authentication',
  'mobile_menu.sell_spirits.shipping_guide' = 'mobile_menu.sell_spirits.shipping_guide',
  'mobile_menu.sell_spirits.bottle_condition' = 'mobile_menu.sell_spirits.bottle_condition',
  'mobile_menu.about_spiritory.about_spiritory' = 'mobile_menu.about_spiritory.about_spiritory',
  'mobile_menu.about_spiritory.how_it_works' = 'mobile_menu.about_spiritory.how_it_works',
  'mobile_menu.about_spiritory.buyer_guide' = 'mobile_menu.about_spiritory.buyer_guide',
  'mobile_menu.about_spiritory.seller_guide' = 'mobile_menu.about_spiritory.seller_guide',
  'mobile_menu.about_spiritory.authentication' = 'mobile_menu.about_spiritory.authentication',
  'mobile_menu.about_spiritory.portfolio_guide' = 'mobile_menu.about_spiritory.portfolio_guide',
  'mobile_menu.about_spiritory.bottle_condition' = 'mobile_menu.about_spiritory.bottle_condition',
  'mobile_menu.about_spiritory.collection' = 'mobile_menu.about_spiritory.collection',
  'mobile_menu.about_spiritory.shipping_guide' = 'mobile_menu.about_spiritory.shipping_guide',
  'mobile_menu.about_spiritory.help' = 'mobile_menu.about_spiritory.help',
  'mobile_menu.blog' = 'mobile_menu.blog',
  'mobile_menu.faq' = 'mobile_menu.faq',
  'mobile_menu.contact' = 'mobile_menu.contact',
  'mobile_menu.type.whisky' = 'mobile_menu.type.whisky',
  'mobile_menu.type.wine' = 'mobile_menu.type.wine',
  'mobile_menu.type.rum' = 'mobile_menu.type.rum',
  'mobile_menu.type.gin' = 'mobile_menu.type.gin',
  'mobile_menu.type.champagne' = 'mobile_menu.type.champagne',
  'mobile_menu.type.liquor' = 'mobile_menu.type.liquor',
  'mobile_menu.countries.scotland' = 'mobile_menu.countries.scotland',
  'mobile_menu.countries.france' = 'mobile_menu.countries.france',
  'mobile_menu.countries.japan' = 'mobile_menu.countries.japan',
  'mobile_menu.topics.most_watched' = 'mobile_menu.topics.most_watched',
  'mobile_menu.topics.most_popular' = 'mobile_menu.topics.most_popular',
  'mobile_menu.topics.new' = 'mobile_menu.topics.new',
  'mobile_menu.open_user_menu' = 'mobile_menu.open_user_menu',
  'mobile_menu.account' = 'mobile_menu.account',
  'mobile_menu.close_menu' = 'mobile_menu.close_menu',
  'mobile_menu.sign_in' = 'mobile_menu.sign_in',
  'mobile_menu.sign_out' = 'mobile_menu.sign_out',
  'search_on_spiritory' = 'search_on_spiritory',
  'go_to_sku_name' = 'go_to_sku_name',
  'spiritory_newsletter.newsletter' = 'spiritory_newsletter.newsletter',
  'spiritory_newsletter.subscribe_to_our_newsletter' = 'spiritory_newsletter.subscribe_to_our_newsletter',
  'spiritory_newsletter.email_address' = 'spiritory_newsletter.email_address',
  'spiritory_newsletter.subscribe' = 'spiritory_newsletter.subscribe',
  'spiritory_newsletter.subscribing_to_newsletter' = 'spiritory_newsletter.subscribing_to_newsletter',
  'spiritory_newsletter.successfully_subscribed' = 'spiritory_newsletter.successfully_subscribed',
  'spiritory_newsletter.error_subscribing' = 'spiritory_newsletter.error_subscribing',
  'dashboard_menu.main.referral' = 'dashboard_menu.main.referral',
  'sign_up' = 'sign_up',
  'sign_in' = 'sign_in',
}

export { HeaderEnum };
